import { instantsInterceptor, } from '@/api/index';

function getEmailGroup(useYn) {
    return instantsInterceptor.post('/mgmt/mail/group/list', { useYn: useYn });
}

function saveEmailGroup(group) {
    return instantsInterceptor.post('/mgmt/mail/group/save', group);
}

function getGroupDetail(groupId) {
    return instantsInterceptor.post('/mgmt/mail/group/detail', { groupId: groupId });
}

function deleteEmailGroup(group) {
    return instantsInterceptor.post('/mgmt/mail/group/delete', group);
}

function saveGroupUser(userList) {
    return instantsInterceptor.post('/mgmt/mail/group/user/save', userList);
}

function getEmailTemplateList(form) {
    return instantsInterceptor.post('/mgmt/mail/template/list', form);
}

function getEmailTemplateDetail(templateId) {
    return instantsInterceptor.post('/mgmt/mail/template/detail', { templateId: templateId });
}

function saveTemplate(template) {
    return instantsInterceptor.post('/mgmt/mail/template/save', template);
}

function deleteTemplate(template) {
    return instantsInterceptor.post('/mgmt/mail/template/delete', template);
}

function getEmailList(form) {
    return instantsInterceptor.post('/mgmt/mail/list', form);
}

function sendMail(mail) {
    return instantsInterceptor.post('/mgmt/mail/send', mail);
}

function getSendMail(mailId) {
    return instantsInterceptor.post('/mgmt/mail/detail', { mailId: mailId });
}



export {
    getEmailGroup,
    saveEmailGroup,
    getGroupDetail,
    deleteEmailGroup,
    saveGroupUser,
    getEmailTemplateList,
    getEmailTemplateDetail,
    getEmailList,
    sendMail,
    getSendMail,
    saveTemplate,
    deleteTemplate
};